import { ChangeEvent, FormEvent, MouseEvent, useEffect, useState } from "react";
import DateRangeForm from "./components/DateRangeForm";
import FilteredTable from "./FilteredTable";
import { connect } from "react-redux";
import { DateRangeInput, DateRangeInputError } from "modules/user_management/dcdd_user/users/state/actionType";
import { fetchDcddUsersByDateRange, resetDcddUserDetails } from "modules/user_management/dcdd_user/users/state/action";
import { ApiError } from "components";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const FetchDcddUser: React.FC<Props> = ({ onFetchDcddUser,fetchDcddUsers, onResetData }) => {
  const [formData, setFormData] = useState<DateRangeInput>({
    fromDate: "",
    toDate: "",
  });
  const [error, setError] = useState<DateRangeInputError>({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(null);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const newFormData = { ...prevData, [name]: value };

      let newErrors: DateRangeInputError = { ...error };

      if (newFormData.fromDate && newFormData.toDate) {
        if (newFormData.fromDate > newFormData.toDate) {
          newErrors.fromDate = "From date should be earlier than To date";
          newErrors.toDate = "To date should be later than From date";
        } else {
          newErrors.fromDate = "";
          newErrors.toDate = "";
        }
      } else {
        newErrors.fromDate = "";
        newErrors.toDate = "";
      }

      setError(newErrors);

      return newFormData;
    });
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();

    const errors: DateRangeInputError = {};

    if (!formData.fromDate) {
      errors.fromDate = "From date is required";
    }
    if (!formData.toDate) {
      errors.toDate = "To date is required";
    }

    if (
      formData.fromDate &&
      formData.toDate &&
      formData.fromDate > formData.toDate
    ) {
      errors.fromDate = "From date should be earlier than To date";
      errors.toDate = "To date should be later than From date";
    }

    setError(errors);

    if (Object.keys(errors).length === 0) {
    }
    setSubmitted(true);
    setLoading(true);

    try {
      await onFetchDcddUser(formData);
    } catch (err) {
      console.error("Failed to fetch user:", err);
    } finally {
      setLoading(false); // always runs, even if fetch throws
    }
  };
const dcddUsers = fetchDcddUsers.filteredDcddUser
  useEffect(() => {
    onResetData();
    if (!fetchDcddUsers.isLoading && submitted) {
      if (fetchDcddUsers.error) {
        setApiError(fetchDcddUsers.error);
      } else {
        setApiError(null);
      }
    }
  }, [fetchDcddUsers.isLoading, fetchDcddUsers.error, submitted]);
  return (
    <>
      <div className="mx-8 mt-8">
        <h2 className="text-2xl font-medium mb-2">
          Search the DCDD users by date range
        </h2>
        <DateRangeForm
          formData={formData}
          error={error}
          loading={loading}
          handleChange={handleChange}
          handleSubmit={handleSave}
        />
        <div className="border mt-8" />
      </div>
      {apiError && <ApiError>{apiError}</ApiError>}
      {fetchDcddUsers.filteredDcddUser &&
      fetchDcddUsers.filteredDcddUser.length > 0 ? (
         <FilteredTable dcddUserData={dcddUsers} />
      ) : (
        <div className="h-[20vh] flex justify-center items-center text-xl font-medium text-primary-400">
          No data to show
        </div>
      )}
     
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    fetchDcddUsers: state.dcddUser.dcddUserState,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  onFetchDcddUser: (input: DateRangeInput) =>
    dispatch(fetchDcddUsersByDateRange(input)),
   onResetData: () => dispatch(resetDcddUserDetails()),
});
export default connect(mapStateToProps, mapDispatchToProps)(FetchDcddUser);
